module.exports = __webpack_public_path__ + "img/undraw_nature_m5ll.22b08523.svg";